export default Object.freeze({
  Admin: 'RoleAdmin',
  SuperAdmin: 'RoleSuperAdmin',
  Support: 'RoleSupport',
  User: 'RoleUser',
  Collaborator: 'RoleCollaborator',
  Auditor: 'RoleAuditor',
  UserManager: 'RoleUserManager',
  Partner: 'RolePartner',
});
